import {
    gql
} from "@apollo/client";

export const CONTACT_US = gql`
    mutation contactUs($request: ContactUsRequest) {
        contactUs(input: $request)
    }
`;
